import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BUSINESS, resumeOrderPayment } from '../config';

// Reprise de paiement (lien de relance) : régénère un checkout PayPal frais pour une
// commande spéciale en attente puis redirige vers PayPal. En cas d'erreur (commande déjà
// réglée / annulée / lien invalide), on affiche un message + le téléphone boutique.
export default function ResumeOrder() {
  const { token } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = 'Reprise de paiement — Atelier Météris';
    let cancelled = false;
    (async () => {
      try {
        const r = await resumeOrderPayment(token);
        // `parseApiResponse` (config.js) DÉBALLE déjà l'enveloppe `{success, data}` :
        // la réponse vaut directement `{approval_url}`. Lire `r.data.approval_url`
        // renvoyait toujours `undefined`, donc « lien invalide » à chaque relance —
        // et ce chantier fait du paiement en ligne le mode par défaut de tout panier
        // mixte, donc de toute relance d'impayé. Les deux formes sont acceptées : la
        // page ne doit plus jamais retomber en panne silencieuse sur ce détail.
        const url = (r && r.approval_url) || (r && r.data && r.data.approval_url);
        if (url) {
          window.location.href = url;
        } else if (!cancelled) {
          setError('Lien invalide ou commande déjà réglée.');
        }
      } catch (e) {
        if (!cancelled) {
          setError(`Cette commande n'est plus payable. Contactez-nous au ${BUSINESS.telephone}.`);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div style={{ padding: 48, textAlign: 'center', minHeight: '40vh' }}>
      {error
        ? <p style={{ color: '#b91c1c', fontSize: 16 }}>{error}</p>
        : <p style={{ fontSize: 16 }}>Redirection vers le paiement sécurisé…</p>}
    </div>
  );
}
